import TypeHelper from '@/helpers/TypeHelper';
import ArrayHelper from '@/helpers/ArrayHelper'
import { FeaturesClaims } from '@/helpers/ClaimsHelper';

export default {
  async fetchProfile({ commit, getters }) {
    const id: string = getters['userId'];
    if (!id || !id.length) {
      return;
    }
    const profileUrl = `${this._vm.$service.UserProfile_Api_Url}Settings/${id}`;
    const response = await this._vm.$api.get(profileUrl, null, 'Your user profile is missing required information. Please edit your profile on the Settings > Personal Settings > Profile page.');
    if (response && response.data) {
      commit('setProfile', response.data);
    }
  },
  async fetchAppVersion({ commit }) {
    const versionPayload = `${this._vm.$service.Infrastructure_Api_Url}version/`;
    fetch(versionPayload)
      .then(response => response.json())
      .then(data => commit('setAppVersion', data));
  },
  async fetchFeatureFlags({ commit })
  {
    try
    {
      const formatFlags = (flags: string[]): string[] =>
      {
        const prepend: string = FeaturesClaims.FeaturePrependText;

        for (let i = 0; i < flags.length; i++)
        {
          // Features have the prepend text added to ensure they do not conflict if, by chance, a token claim has the ...
          // ... same name as a feature. E.g. token claim lists are merged for use in the UI. See permissions.plugin.ts
          flags[i] = `${prepend}${flags[i]}`;
          //console.log('Feature Added', flags[i]);
        }

        return flags;
      };

      fetch(`${this._vm.$service.Organization_Api_Url}Configuration/GetFeatureFlags`)
        .then(response => response.json())
        .then(data => commit('setFeatureFlags', TypeHelper.isArray(data) && ArrayHelper.isArraySet(data) ? formatFlags(data) : []));
    }
    catch {
      commit('setFeatureFlags', []);
    }
  },
  inactiveLogout({ dispatch }): void {
    dispatch('snackbar/setMessage', {
      status: 'error',
      text: 'Your session timed out due to inactivity.'
    }, { root: true });
    setTimeout(() => {
      dispatch('oidc/signOutOidc', null, { root: true });
    }, 3000);
  },
};
